import Cookies from 'universal-cookie';
import { getCookieOptions } from '../utils/utils';
import { clerkSignOut, getClerkToken } from './clerk';

const APP_NAME = 'id360';
const FALLBACK_ADMIN_PATH = '/admin/profiles/recent';

const cookies = new Cookies();

const normalizePath = (path) => {
  if (!path || path === '/admin/login') {
    return FALLBACK_ADMIN_PATH;
  }

  return path.startsWith('/') ? path : `/${path}`;
};

const buildAbsoluteRedirectUrl = (path = FALLBACK_ADMIN_PATH) => {
  const normalizedPath = normalizePath(path);

  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return `${window.location.origin}${normalizedPath}`;
  }

  return normalizedPath;
};

export const getRequestedAdminPath = () => {
  if (typeof window === 'undefined') {
    return FALLBACK_ADMIN_PATH;
  }

  const { pathname, search } = window.location;
  return normalizePath(`${pathname || ''}${search || ''}`);
};

export const getLegacyAuthToken = () => cookies.get('auth') || null;

export const buildIdCloudLoginUrl = (path = FALLBACK_ADMIN_PATH) => {
  const normalizedPath = normalizePath(path);
  const params = new URLSearchParams({
    redirect_url: buildAbsoluteRedirectUrl(normalizedPath),
    app: APP_NAME,
    path: normalizedPath
  });

  return `${process.env.REACT_APP_IDCLOUD_HOST}/login?${params.toString()}`;
};

export const buildAdminLoginRoute = (path = FALLBACK_ADMIN_PATH) => {
  const params = new URLSearchParams({
    path: normalizePath(path)
  });

  return `/admin/login?${params.toString()}`;
};

export const redirectToIdCloudLogin = (path = FALLBACK_ADMIN_PATH) => {
  window.location.href = buildIdCloudLoginUrl(path);
};

export const clearLegacyAuth = () => {
  const options = getCookieOptions();
  cookies.remove('auth', { path: options.path, domain: options.domain });
  cookies.remove('auth', { path: options.path });
  cookies.remove('logged-in', { path: options.path, domain: options.domain });
  cookies.remove('logged-in', { path: options.path });
};

export const resolveActiveAuth = async () => {
  const legacyToken = getLegacyAuthToken();
  if (legacyToken) {
    return { token: legacyToken, source: 'legacy' };
  }

  const clerkToken = await getClerkToken();
  if (clerkToken) {
    return { token: clerkToken, source: 'clerk' };
  }

  return { token: null, source: null };
};

export const logoutActiveAuth = async ({ authSource } = {}) => {
  clearLegacyAuth();

  if (authSource === 'clerk') {
    await clerkSignOut();
    return;
  }

  await clerkSignOut();
};
